function toExponential(n: number, exponent: number = 0): number {
  return Number(`${n}e${exponent}`);
}

type DecimalPlacesPrecision = number;

export const tooMuchPrecision = new Error('too much precision, exponential form will be NaN');

export function roundDecimal(n: number, toPrecision: DecimalPlacesPrecision): number {
  if (toPrecision > 19) throw tooMuchPrecision;
  return toExponential(Math.round(toExponential(n, toPrecision)), -toPrecision);
}
